<template>
  <div class="signup-view">
    <div class="container">
      <RouterView />
    </div>
    <div class="container">
      <p class="fs-9 text-body-tertiary signup-legal-section mt-3 text-center">
        {{ $t("signup.legal.byJoining") }}
        <a
          href="https://soldera.org/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="signup-link"
        >
          {{ $t("signup.legal.membershipAgreement") }}
        </a>
        <br class="d-none d-md-inline" />
        {{ $t("signup.legal.personalDataNote") }}
        <a
          :href="privacyPolicyLink"
          target="_blank"
          rel="noopener noreferrer"
          class="signup-link"
        >
          {{ $t("signup.legal.privacyPolicy") }}
        </a>
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouteParams } from "@vueuse/router";
import { computed } from "vue";

const country = useRouteParams("country", "EN", {
  transform: (value) => value.toUpperCase(),
});

const PRIVACY_POLICY_LINKS: Record<string, string> = {
  EE: "https://www.soldera.org/et/vastavus/privaatsuspoliitika",
  LV: "https://www.soldera.org/lv/atbilstiba/privatuma-politika",
  LT: "https://www.soldera.org/lt/atitiktis/privatumo-politika",
  EN: "https://www.soldera.org/compliance/privacy-policy",
};

const privacyPolicyLink = computed(
  () => PRIVACY_POLICY_LINKS[country.value] ?? PRIVACY_POLICY_LINKS["EN"]
);
</script>

<style scoped lang="scss">
.signup-view {
  overflow-y: auto;
  // Custom container styles
  .container {
    max-width: 800px;
  }
}

.signup-legal-section {
  a.signup-link {
    color: rgb(var(--phoenix-primary-light-rgb));
    font-weight: 500;
    &:hover {
      color: rgb(var(--phoenix-link-color-rgb));
    }
  }
}
</style>
